(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tslib"), require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define(["tslib", "@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["ngForage"] = factory(require("tslib"), require("@angular/core"));
	else
		root["ngForage"] = factory(root["tslib"], root["ng"]["core"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition